import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateEducationInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    education_level: '',
    field_of_study: '',
    professional_training: ''
  });

  useEffect(() => {
    if (christian) {
      setFormData({
        education_level: christian.education_level || '',
        field_of_study: christian.field_of_study || '',
        professional_training: christian.professional_training || ''
      });
    }
  }, [christian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/christian/update/${christian.id}`, formData);  // CHANGE THIS LINE
      onUpdate();
    } catch (error) {
      console.error("Error updating education info:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.education}
          </label>
          <select
            name="education_level"
            value={formData.education_level}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >

  <option value="">Select education level</option>
  <option value="Amashuri abanza">Amashuri abanza</option>
  <option value="Amashuri yisumbuye">Amashuri yisumbuye</option>
  <option value="Ikiciro cya 1 cya Kaminuza (A1)">Ikiciro cya 1 cya Kaminuza (A1)</option>
  <option value="Ikiciro cya 2 cya Kaminuza (A0)">Ikiciro cya 2 cya Kaminuza (A0)</option>
  <option value="Ikiciro cya 3 cya Kaminuza (Masters)">Ikiciro cya 3 cya Kaminuza (Masters)</option>
  <option value="PhD">PhD</option>
</select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.field_of_study}
          </label>
          <input
            type="text"
            name="field_of_study"
            value={formData.field_of_study}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.training}
          </label>
          <input
            type="text"
            name="professional_training"
            value={formData.professional_training}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateEducationInfo;